import { types } from "../action-types";

const initialState = {
    loading: false,
    loadingAbout: false,
    details: [],
    error: false,
    dropdown: [],
    success: false,

};

const getCompanyDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_COMPANY_DETAILS_REQUESTED:
            return {
                ...state,
                loading: true,
                success: false,
            };

        case types.GET_COMPANY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                dropdown: action.payload,
                error: false,
            };
        case types.GET_COMPANY_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                dropdown: [],
                error: true,
            };
        case types.POST_COMPANY_DETAILS_REQUESTED: 
            return {
                ...state,
                loading: true,
                loadingAbout: true,
                success: false,
            };
        case types.POST_COMPANY_DETAILS_SUCCESS:
            // This response does not carry Source, so replacing the key outright
            // used to drop it — and Source is what gates Skill Radar for the rest
            // of the session. Carry just that one field over; every other field
            // still comes from this response exactly as before.
            try {
                const storedProfile = JSON.parse(localStorage.getItem('userProfile') || 'null');
                const isPlainPayload =
                    action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload);
                if (isPlainPayload && storedProfile?.Source && !action.payload.Source) {
                    localStorage.setItem(
                        'userProfile',
                        JSON.stringify({ ...action.payload, Source: storedProfile.Source })
                    );
                } else {
                    localStorage.setItem('userProfile', JSON.stringify(action.payload));
                }
            } catch {
                localStorage.setItem('userProfile', JSON.stringify(action.payload));
            }
            return {
                ...state,
                details: action.payload,
                error: false,
                success: true,
                loadingAbout: false,
                // loading: false,
            }
        case types.POST_COMPANY_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                loadingAbout: false,
                details: [],
                error: true,
                success: false,
            }
        case types.POST_COMPANY_DETAILS_RESET:
            return {
                ...state,
                details: [],
                loading: false,
                loadingAbout: false,
                success: false,
            }
        case types.POST_TALENT_DETAILS_RESET:
            return {
                ...state,
                details: [],
                loading: true,
                success: false,
            }
        default:
            return state;
    }
};

export default getCompanyDetailsReducer;
